import config from 'config';
import { BUSINESS_UNITS } from 'core';
import { styled, theme } from 'ui/theme';
const isEudTheme = BUSINESS_UNITS.EUD === config.app.short;
const iconColors = isEudTheme
  ? theme.colors.build.brand2
  : theme.colors.action.nonInteractive.emphasis;
export const Icon = {
  Wrapper: styled.div`
    &[data-text-align='center'] {
      text-align: -webkit-center;
    }
    &[data-text-align='left'] {
      text-align: -webkit-left;
    }
    &[data-text-align='right'] {
      text-align: -webkit-right;
    }

    // Colors
    &[data-color='brand-1'] {
      color: ${iconColors};
    }

    &[data-color='brand-2'] {
      color: ${iconColors};
    }
  `,
};
